<div class="title">Status History</div>

<div class="history-items">
  @for (item of historyItems; track item; let idx = $index) {
    @if (idx > 0) {
      <div class="separator-line"></div>
    }
    <div class="history-item">
      <div class="history-item-header">
        <div class="history-date">{{ item.updatedAt | dateFormat | notAvailable }}</div>
        <div [class]="'inline-status inline-status-' + item.status | lowercase">{{ item.status | titlecase }}</div>
      </div>
      <div class="history-reason">
        {{ item.reason }}
      </div>
      <div class="history-updated-by">
        Updated by {{ $safeNavigationMigration(item.updatedBy?.id) | teamMemberName | async | notAvailable }}
      </div>
    </div>
  }
</div>

<div class="buttons">
  <button rktButton title="Close" (click)="activeModal.close(true)">Close</button>
</div>
